export const STEPUP_TOKEN_ENDPOINT = 'https://users.wix.com/oauth/token';

export interface ExchangeCodeForTokenParams {
  code: string;
  clientId: string;
  redirectUri: string;
  codeVerifier: string;
}

/**
 * Exchanges the OAuth authorization code (pre-authorized by account-settings)
 * for an access token, completing the PKCE flow on our side.
 *
 * Uses `credentials: include` so the session cookie rides along, and never logs
 * the code or verifier.
 */
export const exchangeCodeForToken = async ({
  code,
  clientId,
  redirectUri,
  codeVerifier,
}: ExchangeCodeForTokenParams): Promise<string> => {
  const body = new URLSearchParams({
    grant_type: 'authorization_code',
    code,
    client_id: clientId,
    redirect_uri: redirectUri,
    code_verifier: codeVerifier,
  });

  const response = await fetch(STEPUP_TOKEN_ENDPOINT, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: body.toString(),
  });

  if (!response.ok) {
    throw new Error(
      `Step-up token exchange failed with status ${response.status}`,
    );
  }

  const data = (await response.json()) as { access_token?: string };
  if (!data?.access_token) {
    throw new Error('Step-up token exchange response missing access_token');
  }
  return data.access_token;
};
